<template>
  <div>
    <el-upload
      action="fakeaction"
      :http-request="handleUpload"
      :multiple="false"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :drag="false"
      :on-success="onSuccess"
    >
      <template>
        <button :style="preViewFileUrl?'background-image:url('+preViewFileUrl+')':''">{{tips}}</button>
      </template>
    </el-upload>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import commonModels from '@/common/models/common-models'
export default {
  name: 'axj-upload',
  props: {
    sourcePath:{
      type:Object,
      default:()=>{
        return{
          module:"user",
          directory:'userAvatar'
        }
      }
    },
    allowType: {
      type: Array,
      default: () => (["image/jpg", "image/jpeg", "image/png"])
    },
    allowSize: {
      type: Number,
      default: 10
    },
    preViewFileUrl:{
      type:String,
      default:undefined
    },
    tips:{
      type:String,
      default:undefined
    }
  },
  data() {
    return {
    }
  },
  methods: {
    onSuccess(obj) {
      this.$emit('success', obj)
    },
    beforeUpload(file) {
      // 是允许的类型
      const is_allowType = this.allowType.indexOf(file.type) >= 0
      // 文件大小判断
      const is_allowSize = file.size / 1024 / 1024 < this.allowSize;
      if (!is_allowType) {
        this.$message.error('未被允许的文件格式!');
      }
      if (!is_allowSize) {
        this.$message.error('文件大小不能超过 ' + this.allowSize + 'MB!');
      }
      return is_allowType && is_allowSize;
    },
    handleUpload(params){
      // 记录file以及fileType
      const file = params.file,fileType = params.file.type;
      // 获取文件后缀
      const file_extension = file.name.substr(file.name.lastIndexOf('.')+1, file.name.length)
      const fileName = (new Date()).valueOf()+ file.name.substr(file.name.lastIndexOf('.'), file.name.length)
      // 拼接文件路径
      let path = ""
      path += this.sourcePath.module?this.sourcePath.module + "/":"unknow_module" + "/"
      path += this.sourcePath.directory?this.sourcePath.directory + "/":"unknow_source_directory" + "/"
      path += fileName
      // 假的连接0v0，实际上只是返回一个 connect 对象
      var client = commonModels.ossConnect(this.bucketParameter)

      // 大于 2M 的使用分片上传
      if( file.size/1024/1024 >= 2 ){
        console.log("分片上传")
        // 分片上传(ps:大文件适用)
        client.multipartUpload(path, file, {
          // 进度条
          progress: function(p) {
            let percent = Math.ceil(p * 100)
            if (percent > 100) {
              percent = 100;
            }
            // element upload onProgress 上传进度钩子，以便获取实时进度
            params.onProgress(percent)
          }
        })
          .then(response => {
            // response 中有 res 参数
            const { res } = response
            if (res.status === 200) {
              // 自定义返回参数
              let data = {
                uid: file.uid, // 文件的 uid
                name: fileName, // 通过规则生成的文件名
                old_name: file.name, // 上传时的文件名
                type: fileType, // 文件上传组件判断的文件类型
                file_extension: file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的需求 )
                size: file.size, // 文件大小
                url: this.resourcePrefix.url + '/' + response.name, // url
                duration: this.videoDuration ? Math.round(duration) : "videoDuration is false.", // 视频时长
                code: 200 // 状态码
              }
              // element upload onSuccess 上传成功钩子
              params.onSuccess(data)
            }
          })
          .catch(error => {
            // element upload onError 上传失败钩子
            params.onError(error)
          })
      } else {
        console.log("文件流上传")
        client.put(path, file)
          .then(response => {
            // response 中有 res 参数
            const { res } = response
            if (res.status === 200) {
              // 自定义返回参数
              let data = {
                uid: file.uid, // 文件的 uid
                name: fileName, // 通过规则生成的文件名
                old_name: file.name, // 上传时的文件名
                type: fileType, // 文件上传组件判断的文件类型
                file_extension: file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的统以要求 )
                size: file.size, // 文件大小
                url: this.resourcePrefix.url + '/' + response.name, // url
                duration: this.videoDuration ? Math.round(duration) : "videoDuration is false.", // 视频时长
                code: 200 // 状态码
              }
              // element upload onSuccess 上传成功钩子
              params.onSuccess(data)
            }
          })
          .catch(error => {
            // element upload onError 上传失败钩子
            params.onError(error)
          })
      }
    }
  },
  computed: {
    ...mapState( [
      'bucketParameter',
      'resourcePrefix'
    ])
  },
  watch: {

  },
}

</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/axj-upload/index.vue